import React, { useEffect } from 'react';
import { setEditedProfile } from '../../../redux/applicationSlice';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useDispatch, useSelector } from 'react-redux';
import FocusButtons from './FocusButtons';
import ViewingRestrictionItems from './viewingRestrictionItems';

const ViewingRestrictionPopup = ({
    pgRatings,
    showPgRatingSelector,
    setShowPgRatingSelector,
}) => {

    const dispatch = useDispatch();
    const { theme, editedProfile } = useSelector((state) => state.application);

    const { ref, focused, setFocus, focusSelf } = useFocusable({
        focusKey: "viewingRestrictionPopup",
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            return true;
        },
        onEnterRelease: () => { },
    });

    useEffect(() => {
        if (showPgRatingSelector) {
            focusSelf();
        }
    }, [showPgRatingSelector]);

    return (
        <FocusContext.Provider value={"viewingRestrictionPopup"} >
            <div ref={ref} className={`smileySelector pgRatingSelector ${!showPgRatingSelector && 'hidden'}`}>
                <p style={{ textAlign: "left", paddingLeft: "5px" }}>
                    <div style={{ position: "absolute", right: "5px", top: "10px", }}>
                        <FocusButtons focusKey='clearPgRatings' bgColor='#e84d31' text='Clear All' onClick={() => { dispatch(setEditedProfile({ ...editedProfile, Restricted_PgRatings: [] })); setShowPgRatingSelector(false); }} />
                        <FocusButtons focusKey='savePgRatings' bgColor='#1da1f2' text='Done' onClick={() => {
                            dispatch(setEditedProfile({ ...editedProfile, EnablePgRestriction: editedProfile.Restricted_PgRatings.length > 0 ? true : false }));
                            setShowPgRatingSelector(false);
                        }} />
                    </div>
                    Select PG Rating
                </p>
                {pgRatings.map((pgRating, index) => {
                    let selected = editedProfile?.Restricted_PgRatings.some((pgr) => { return pgr?._id == pgRating?._id });
                    return <ViewingRestrictionItems key={index} index={index} pgRating={pgRating} selected={selected} onClick={() => {
                        if (selected) {
                            dispatch(setEditedProfile({ ...editedProfile, Restricted_PgRatings: editedProfile?.Restricted_PgRatings.filter((pgr) => { return pgr?._id != pgRating?._id }) }));
                        } else {
                            dispatch(setEditedProfile({ ...editedProfile, Restricted_PgRatings: [...editedProfile?.Restricted_PgRatings, pgRating] }));
                        }
                        focusSelf();
                    }} />;
                })}
            </div>
        </FocusContext.Provider>
    );
}

export default ViewingRestrictionPopup;
